import React from 'react';

import { StackView, Paragraph, Divider } from '@telus-uds/components-web';

import { ContentWrapper } from '../design/css';

const Success = () => {
  return (
    <>
      <StackView space={4}>
        <Divider />
        <Divider />
      </StackView>
      <div className="container 85%">
        <ContentWrapper style={{ minHeight: 'auto' }}>
          <Paragraph>
            Thank you for choosing TELUS Fully Managed. Our Managed IT services
            support your day-to-day IT needs so you can stay focused on what's
            important. We have received confirmation of the customer agreement
            and will proceed with setting up your solution as requested.
          </Paragraph>
          <Paragraph>
            If you have questions about your TELUS Fully Managed solution,
            please contact your Account Manager.
          </Paragraph>
        </ContentWrapper>
      </div>
    </>
  );
};

export default Success;
